const MAX_ATTEMPTS = 3;

/**
 * Fetches a request with exponential backoff on 503 responses.
 * Attempt delays: 2s, 4s, 6s (attempt * 2000ms), up to MAX_ATTEMPTS.
 * Returns undefined on 401, 403, or non-ok responses after exhausting retries.
 *
 * @param {Request} request
 * @param {number} attempt
 * @returns {Promise<any|undefined>}
 */
export async function fetchWithBackoff(request, attempt = 1) {
  try {
    const response = await fetch(request.clone());
    if (response.status === 401 || response.status === 403) return;
    if (response.status === 503 && attempt < MAX_ATTEMPTS) {
      await new Promise(function(resolve) { setTimeout(resolve, attempt * 2000); });
      return fetchWithBackoff(request, attempt + 1);
    }
    if (!response.ok) return;
    return response.json();
  } catch (err) {
    console.error('fetch error', err);
  }
}
